import { render } from "./QC1AreaRetention.vue?vue&type=template&id=32bdbe1a"
import script from "./QC1AreaRetention.vue?vue&type=script&lang=js"
export * from "./QC1AreaRetention.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/QCCharts/QC1AreaRetention.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "32bdbe1a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('32bdbe1a', __exports__)) {
    console.log('reload')
    api.reload('32bdbe1a', __exports__)
  }
  
  module.hot.accept("./QC1AreaRetention.vue?vue&type=template&id=32bdbe1a", () => {
    console.log('re-render')
    api.rerender('32bdbe1a', render)
  })

}


export default __exports__